import { MILLISECONDS_IN_MINUTE, getDayDate } from "src/app/utils/date.util";
import { EDalyTimeSlotLocation } from "../daly-time-slot.entity/daly-time-slot";

export interface IDoctorAvailability {
    date: Date,
    startTime: number,
    duration: number,
    private: boolean,
    location: EDalyTimeSlotLocation
}

export class DoctorAvailability implements IDoctorAvailability {
    date: Date;
    startTime: number;
    duration: number;
    private: boolean;
    location: EDalyTimeSlotLocation;
    constructor(other?: Partial<IDoctorAvailability>) {
        this.date = other?.date || new Date(0);
        this.startTime = other?.startTime || 0;
        this.duration = other?.duration || 30;
        this.private = other?.private || false;
        this.location = other?.location || EDalyTimeSlotLocation.ATSITE;
    }

    get endTime(): number {
        return this.startTime + (this.duration * MILLISECONDS_IN_MINUTE);
    }
    public static fromResponse(res: any): DoctorAvailability {
        return new DoctorAvailability({
            date: getDayDate(new Date(res.date)),
            location: res.location,
            duration: res.duration,
            startTime: res.startTime,
            private: res.private
        });
    }

}